<template>
  <div>
    <HelpTip v-bind="labelInfo"></HelpTip>
    <van-field
      class="select-temp work-temp-form-item"
      :name="id"
      :rules="[
        {
          required: required,
          message: languages.smartOrderPleaseChoose + label
        }
      ]"
      :value="curValue"
    >
      <template #input>
        <div class="select">
          <select
            ref="selectEle"
            style="
              float: left;
              z-index: 0;
              position: relative;
              width: 100%;
              height: 100%;
              background-color: transparent;
              color: inherit;
              outline: inherit;
              border: 0;
              font-size: inherit;
              cursor: pointer;
            "
            v-model="curValue"
            :disabled="disabled"
            :class="[
              {
                'placeholder-style':
                  customKey.defaultValue == undefined || disabled
              },
              pointClass
            ]"
            @change="onSelect($event.target.value)"
          >
            <option v-if="placeholder" disabled selected :value="undefined">
              {{ placeholder }}
            </option>
            <option
              v-for="item in customKey.options"
              :value="item.value"
              :key="item.value"
            >
              {{ item.label }}
            </option>
          </select>
          <van-icon
            class="select-arrow"
            :class="{
              'placeholder-style': disabled
            }"
            name="arrow-down"
            size="24"
          />
        </div>
      </template>
    </van-field>
  </div>
</template>

<script>
import workTemp from '@mixins/officialSupport/workTemp';
export default {
  name: 'TempSelect',
  mixins: [workTemp],
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    pointClass: {
      type: String,
      default: ''
    },
    customKey: {
      type: Object,
      default: () => ({
        options: {
          type: Array,
          default: () => []
        },
        defaultValue: {
          default: undefined
        }
      })
    }
  },
  data() {
    return {
      curValue: null
    };
  },
  watch: {
    value(val) {
      if (val == this.curValue) return;
      this.curValue = val;
    }
  },
  created() {
    this.curValue = this.customKey.defaultValue;
    this.formData[this.id] = this.customKey.defaultValue;
  },
  methods: {
    onSelect(value) {
      this.$emit('change', value);
      this.formData[this.id] = value;
      const selectEle = this.$refs.selectEle;
      selectEle && typeof selectEle.blur === 'function' && selectEle.blur();
    },
    // 这里和上面的blur，主要是为了避免在选中select的时候切换屏幕再回来时会自动触发聚焦上报。
    selectAutoBlur() {
      if (document?.visibilityState == 'hidden') {
        try {
          const selectElem = this.$refs.selectEle;
          selectElem &&
            typeof selectElem.blur === 'function' &&
            selectElem.blur();
        } catch (error) {
          console.error(error);
        }
      }
    }
  },
  mounted() {
    document.addEventListener('visibilitychange', this.selectAutoBlur);
  },
  beforeUnmount() {
    document.removeEventListener('visibilitychange', this.selectAutoBlur);
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialSupport/workTempForm.scss';
.select {
  display: flex;
  position: relative;
  width: 100%;
  height: 64px;
  padding: 0 17px 0 20px;
  background-color: var(--block-bg-light-color);
  border-radius: var(--border-radius);
  font-size: inherit;
  color: var(--text-color);
  box-sizing: border-box;
  border: 1px solid var(--border-color);

  > select {
    // iOS原生select自带padding
    padding: 0;
    // 去除原生下拉箭头
    -webkit-appearance: none; /* Safari 和 Chrome */
    -moz-appearance: none; /* Firefox */
    appearance: none; /* 其他浏览器 */
    &:disabled {
      color: var(--placeholder-color) !important;
      -webkit-text-fill-color: var(--placeholder-color) !important;
    }
  }

  .placeholder-style {
    color: var(--placeholder-color) !important;
  }

  &-arrow {
    z-index: 0;
    position: relative;
    top: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    font-weight: bold;
    color: #9e9e9e !important;
  }
}
</style>
